interface Stat {
  label: string;
  value: string;
  tone?: 'default' | 'danger';
}

// Полоса крупных чисел под шапкой ("Нарядов сегодня / Просрочено / ..." в макете) —
// общий компонент, значения считает вызывающая страница
export default function StatBar({ stats }: { stats: Stat[] }) {
  return (
    <div className="stat-bar">
      {stats.map((s) => (
        <div key={s.label} className="stat-cell">
          <div className="stat-cell-label">{s.label}</div>
          <div className={`stat-cell-value ${s.tone === 'danger' ? 'stat-cell-value-danger' : ''}`}>
            {s.value}
          </div>
        </div>
      ))}
    </div>
  );
}
